var WDN = WDN || {};

if (typeof WDN.CartDrawer === "undefined") {
  WDN.CartDrawer = (function () {
    var init, isRendered;

    var loading, loadStyles;
    var refresh, onRefresh;

    // Depends on
    var SectionRenderer = WDN.SectionRenderer;

    var drawer = document.querySelector("wdn-drawer[data-id='cart']");

    var state = {
      rendered: false,
      stylesLoaded: false
    };

    isRendered = function () {
      return state.rendered;
    };

    onRefresh = function () {
      state.rendered = true;

      // Configure shipping
      if (WDN.Shipping) {
        WDN.Shipping.reselectNodes();
        WDN.Shipping.outputPrices();
      }
      loading(false);
    };

    /*
      Config options:
        @openDrawer: true/false
    */

    loading = function (isLoading) {
      if (isLoading) {
        drawer.setAttribute("data-loading", "");
        return;
      }
      drawer.removeAttribute("data-loading");
    };

    loadStyles = function () {
      if (state.stylesLoaded) return;
      WDN.StylesheetLoader.load(".cartdrawer-style");
      state.stylesLoaded = true;
    };

    refresh = function (config = {}) {
      loadStyles();

      loading(true);

      WDN.CartCount.update();

      new SectionRenderer({
        selectors: {
          output: "[data-cartdrawer-content]"
        },
        autoInit: true,
        replaceOutput: true,
        sections: ["async-cart-drawer"],
        callback: function () {
          onRefresh();
          if (!config.openDrawer) return;
          drawer.open();
        }
      });
    };

    init = function () {
      var renderer = new SectionRenderer({
        selectors: {
          trigger: "wdn-drawer-open[data-id='cart']",
          output: "[data-cartdrawer-content]"
        },
        replaceOutput: true,
        sections: ["async-cart-drawer"],
        events: ["mouseover", "click"],
        callback: onRefresh
      });

      // Setup callback for interaction (pre-fetch)
      renderer.onInteraction = function () {
        loadStyles();
      };
    };

    init();

    return {
      refresh,
      isRendered
    };
  })();
}

/* Cart drawer multigift */
if (typeof WDN.CartMultiGift === "undefined") {
  WDN.CartMultiGift = (function () {
    class CartMultiGift extends HTMLElement {
      constructor() {
        super();
      }

      onFormSubmit(e) {
        e.preventDefault();
        let form = e.currentTarget;
        let submitButton = form.querySelector("button");

        submitButton.disabled = true;

        // Handles both cart add & cart remove request
        fetch(form.getAttribute("action") + '.js', {
          method: "POST",
          body: new FormData(form)
        })
          .then((res) => {
            WDN.CartDrawer.refresh();
          })
          .catch(() => {
            submitButton.disabled = false;
          });
      }

      removeGiftsFromCart() {
        // Generate payload based on line keys array
        let payload = {};
        this.lineKeys.forEach((key) => {
          payload[key] = 0;
        });

        // Send cart update request and remove cart items
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-type": "application/json"
          },
          body: JSON.stringify({ updates: payload })
        }).then((res) => {
          WDN.CartDrawer.refresh();
        });
      }

      connectedCallback() {
        // Nodes
        this.forms = this.querySelectorAll("form");
        this.dump = JSON.parse(this.querySelector("script").innerText);

        // Properties
        this.cartSubtotalPrice = parseInt(this.dump.subtotal);
        this.giftsInCart = parseInt(this.dump.giftsInCart);
        this.threshold = parseInt(this.dump.threshold);
        this.lineKeys = this.dump.giftLineKeys.split(",");

        // If cart subtotal less than threshold and there are gifts in the cart - remove them
        if (this.cartSubtotalPrice < this.threshold && this.giftsInCart > 0) {
          this.removeGiftsFromCart();
          return;
        }

        // Bind
        this.onFormSubmitBound = this.onFormSubmit.bind(this);
        this.forms.forEach((form) => form.addEventListener("submit", this.onFormSubmitBound));
      }

      disconnectedCallback() {
        this.forms.forEach((form) => form.removeEventListener("submit", this.onFormSubmitBound));
      }
    }

    class CartMultiGiftRemover extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.lineKeys = this.getAttribute("data-line-keys").split(",");
        if (this.lineKeys[0] === "") return;
        let payload = {};
        this.lineKeys.forEach((key) => {
          payload[key] = 0;
        });

        // Send cart update request and remove cart items
        fetch(`${Shopify.routes.root}cart/update.js`, {
          method: "POST",
          headers: {
            "Content-type": "application/json"
          },
          body: JSON.stringify({ updates: payload })
        }).then((res) => {
          WDN.CartDrawer.refresh();
        });
      }
      disconnectedCallback() {}
    }
    customElements.define("cart-multigift-remover", CartMultiGiftRemover);
    customElements.define("cart-multigift", CartMultiGift);
    return CartMultiGift;
  })();
}
